require('./showNotesDialog.less');


class ShowNotesController {
    activeLine;
    historicNotes = [];
    noHistoricNotes;

    constructor(private $mdDialog, private Prognosis, private toastService){
    }

    $onInit () {
        var findAny = this.activeLine.forecastLine.months.find(function(month){
            return month.note && month.note !== null && month.note.length > 0;
        });
        if(!findAny){
            this.noHistoricNotes = true;
        }
    }

    getHistoricNotes () {
        if(this.historicNotes && this.historicNotes !== null && this.historicNotes.length > 0) {
            this.historicNotes = [];
            return;
        }
        this.Prognosis.getNotes({articleNo: this.activeLine.articleNo, forecastTypeId: this.activeLine.id}).$promise.then(
            (result) => {
                if(result && result.length > 0){
                    this.historicNotes = result;
                }else {
                    this.toastService.showSimpleToast("Ingen tilgjengelig historikk", 3000);
                }
            },
            (error) => this.toastService.parseError(error)
        );
    };

    hide () {
        this.$mdDialog.hide();
    };
    cancel () {
        this.$mdDialog.cancel();
    };

    filterFunction () {
        return function(month) {
            return month.note && month.note !== null && month.note.length > 0;
        };
    };

    months = [
        {title:'Januar', name:'januar'},
        {title:'Februar', name:'februar'},
        {title:'Mars', name:'mars'},
        {title:'April', name:'april'},
        {title:'Mai', name:'mai'},
        {title:'Juni', name:'juni'},
        {title:'Juli', name:'juli'},
        {title:'August', name:'august'},
        {title:'September', name:'september'},
        {title:'Oktober', name:'oktober'},
        {title:'November', name:'november'},
        {title:'Desember', name:'desember'},
    ];

}


class ShowNotesOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "showNotesDialogController";
    public template: any = require('./showNotesDialog.html');
    bindings: any = {
        activeLine:'='
    };

}


rkcApp.controller("showNotesDialogController", ['$mdDialog', 'Prognosis', 'toastService', function ($mdDialog, Prognosis, toastService) {
    return new ShowNotesController($mdDialog, Prognosis, toastService);
}])
    .component("showNotesDialog", new ShowNotesOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/prognosis/showNotesDialog/showNotesDialog.ts
 **/